module.exports = __webpack_public_path__ + "static/monash-da468d2cccc8c62cac4f45cde39164a5.png";